import PortfolioImageChangeContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioImageChange";

const PortfolioImageChange = () => {
  return <PortfolioImageChangeContainer />;
};

export default PortfolioImageChange;
